module.exports = __webpack_public_path__ + "img/14@2x.377a1c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/14@2x.png
// module id = tF6W
// module chunks = 0